'use client';

import { ThemeProvider } from 'next-themes';
import { usePathname } from 'next/navigation';
import { createContext, useEffect, useRef } from 'react';

import { SnackbarProvider } from '@/components/ui/snackbar';

function usePrevious<T>(value: T) {
  const ref = useRef<T>(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

export const AppContext = createContext<{ previousPathname?: string }>({});

export function Providers({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const previousPathname = usePrevious(pathname);

  return (
    <AppContext.Provider value={{ previousPathname }}>
      <ThemeProvider
        attribute="class"
        disableTransitionOnChange
        enableColorScheme
        forcedTheme="light"
        defaultTheme="light"
        storageKey="theme-mode"
        themes={['light']}
      >
        <SnackbarProvider>{children}</SnackbarProvider>
      </ThemeProvider>
    </AppContext.Provider>
  );
}
